export default {
  'notification.title': '通知',
  'notification.empty': '暂无通知',
  'notification.empty.unread': '暂无未读通知',
  'notification.markAllRead': '全部已读',
  'notification.markAllRead.success': '已全部标记为已读',
  'notification.markAllRead.failed': '标记失败，请重试',
  'notification.markRead': '标为已读',
  'notification.markRead.success': '已标记为已读',
  'notification.markRead.failed': '标记失败，请重试',
  'notification.tab.all': '全部',
  'notification.type.system': '系统',
  'notification.type.transaction': '交易',
  'notification.type.marketing': '营销',
  'notification.time.now': '刚刚',
  'notification.time.minutes': '{count} 分钟前',
  'notification.time.hours': '{count} 小时前',
  'notification.time.days': '{count} 天前',
  'notification.filter.label': '筛选',
  'notification.filter.all': '全部',
  'notification.filter.unreadOnly': '未读',
};
